import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiTrendingUp, FiCpu, FiAward } = FiIcons;

const expertise = [
  {
    title: 'Institutional Governance',
    text: 'Leveraging decades of executive experience to support large-scale institutional IT infrastructure and strict operational oversight.'
  },
  {
    title: 'Fiscal Stewardship',
    text: 'Deep background in financial services, ensuring precise transaction oversight, fiduciary processes, and budget efficiency.'
  },
  {
    title: 'Strategic Agility',
    text: 'Bridging the gap between complex federal and state requirements with the responsive execution of a dedicated IT partner.'
  }
];

export default function About() {
  const getIcon = (index) => {
    switch(index) {
      case 0: return FiShield;
      case 1: return FiTrendingUp;
      case 2: return FiCpu;
      default: return FiShield;
    }
  };

  return (
    <section id="about" className="bg-slate-50/50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-16 lg:grid-cols-2 lg:items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="text-sm font-bold uppercase tracking-[0.2em] text-slate-400">Leadership</div>
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-slate-800 sm:text-4xl uppercase">
              Corporate Overview.
            </h2>
            <div className="mt-8 space-y-6">
              <p className="text-lg leading-relaxed text-slate-500">
                Headquartered in Huntington Beach, California, MelonEdge LLC is a certified Women-Owned Small Business (WOSB) and Minority-Owned Enterprise (MBE) specializing in institutional-grade IT procurement. Founded by Melissa Ann Guico, the firm translates nearly 20 years of executive leadership into a robust technology supply platform.
              </p>
              <p className="text-lg leading-relaxed text-slate-500">
                We provide localized distribution across California while supporting nationwide federal and institutional requirements. Our mission is to streamline complex purchasing cycles through direct communication, authorized sourcing, and meticulous logistical execution.
              </p>
            </div>

            <div className="mt-12 space-y-8">
              {expertise.map((item, i) => (
                <div key={i} className="flex gap-5">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white border border-slate-100 text-orange-500 shadow-sm">
                    <SafeIcon icon={getIcon(i)} className="h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-slate-800 uppercase tracking-tight">{item.title}</h4>
                    <p className="mt-1 text-slate-500 leading-relaxed">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="mx-auto max-w-md lg:max-w-none">
              <div className="group relative overflow-hidden rounded-[3.5rem] border-[12px] border-white bg-white shadow-2xl shadow-slate-200/60">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/2f6847c5255962cb7ef6c818c843620d0179d6b0e810fa4ca1144f00d96707af10e5b2228b1b15861dc89ecefec6c49b/images/aW1hZ2UvanBlZw==/94892af917203ff5061cd0c931a5115e.jpeg" 
                  alt="Melissa Ann Guico, Founder and President" 
                  className="w-full h-auto block object-cover grayscale-[20%] transition-all duration-700 group-hover:grayscale-0" 
                />
                <div className="absolute bottom-6 left-6 right-6 overflow-hidden rounded-2xl border border-white/30 bg-white/80 p-6 backdrop-blur-xl shadow-xl">
                  <div className="relative z-10">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="text-xl font-black tracking-tight text-slate-900 uppercase">
                          Melissa Ann Guico
                        </h3>
                        <div className="mt-1 flex items-center gap-2">
                          <div className="h-px w-4 bg-orange-500"></div>
                          <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-600">
                            Founder & President
                          </span>
                        </div>
                      </div>
                      <div className="hidden sm:block">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-900/5 text-slate-900">
                          <SafeIcon icon={FiAward} className="h-5 w-5" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}